import React from 'react'

import { DatasetCategory } from 'src/commons/chartjs'
import ComparisonPlot from 'src/commons/graphs/ComparisonPlot'
import TemporalHistogram from 'src/commons/graphs/TemporalHistogram'
import TemporalStackedHistogram from 'src/commons/graphs/TemporalStackedHistogram'
import { IGraphBucketList, IGraphCompare, IGraphStack } from 'src/commons/types'

export function RatioOfTripsPerVehiclePerProvider(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function NumberOfTripsPerVehicle(props: IGraphStack) {
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      adjacentBars={true}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function UtilizationRatePerProvider(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      formatWithUnit={(amount: string) => `${amount}%`}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function UtilizationRate(props: IGraphBucketList) {
  return (
    <TemporalHistogram
      title={props.title}
      rawData={props.graphReport}
      formatWithUnit={(amount: string) => `${amount}%`}
      granularity={props.granularity}
      enableAnimation={props.enableAnimation}
    />
  )
}
